import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/call';

export class CallsService extends RestServiceConnection {

    /**
     * Lista todas las llamadas con filtros opcionales
     */
    listCalls = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: { ...filters }
        }, true) as AxiosResponse;
        return this;
    }

    /**
     * Obtiene una llamada específica por ID
     */
    getCall = async (callId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { callId }
        }, true) as AxiosResponse;
        return this;
    }

    /**
     * Edita una llamada existente
     */
    editCall = async (values: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: values
        }, true) as AxiosResponse;
        return this;
    }

    /**
     * Elimina una llamada por ID
     */
    deleteCall = async (callId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { callId }
        }, true) as AxiosResponse;
        return this;
    }

    /**
     * Elimina múltiples llamadas
     */
    deleteMultipleCalls = async (callIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-multi',
            data: { callIds }
        }, true) as AxiosResponse;
        return this;
    }

    realizeCall = async (phone: string, ocmUserLogin: string, clientId?: string | null, contractId?: string | null) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/realize-call',
            data: { phone, ocmUserLogin, clientId: clientId ?? null, contractId: contractId ?? null },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    listCallRecords = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-records',
            data: { ...filters }
        }, true) as AxiosResponse;
        return this;
    }

    downloadCallRecord = async (callRecordId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/download-record',
            data: { callRecordId },
            responseType: 'blob'
        }, true) as AxiosResponse;
        return this;
    }
}
